import {loadAssets} from "./assets.js";
import {Vector} from "./i.js"; // ./vector.js
import {G, setMousePosition} from "./i.js";
import {keyboard} from "./i.js"; // ./keyboard.js
import {Menu} from "./i.js";

let menu;

async function init() {
	// TODO: Try to load in parallel like this:
	//
	// await Promise.all([
	// 	G.init({
	// 		resizeTo: window,
	// 		antialias: true,
	// 		background: 0x222222
	// 	}),
	// 	loadAssets()
	// ]);
	//
	// That currently breaks XML bitmap font loading for some reason.

	await G.init({
		resizeTo: window,
		antialias: true,
		background: 0x222222,
		// The two parameters below speed up garbage collection
		// Documentation for these parameters is very unclear. I don't how the two are
		// different, but the examples in the Pixi docs had the first number bigger than
		// the second, so I did the same thing. I think these numbers are measured in
		// frames, but I am not sure of that either.
		textureGCMaxIdle: 600,
		textureGCCheckCountMax: 300
	});
	document.body.appendChild(G.canvas);

	await loadAssets();

	menu = new Menu();
	G.stage.addChild(menu.display);

	G.stage.eventMode = "static";
	G.stage.addEventListener("globalpointermove",
		(e) => setMousePosition(new Vector(e.pageX, e.pageY))
	);
	document.body.oncontextmenu = e => e.preventDefault();
	// Workaround for the PixiJS ticker CPU usage bug
	G.ticker.maxFPS = 144;
	G.ticker.add(tick);
}

function tick() {
	// I had this line here for a long time, but I don't think it does anything. If
	// commenting it out doesn't cause any problems, remove it. (January 2026)
	// G.renderer.resize(screenSize.x, screenSize.y);
	menu.update(G.ticker.deltaMS / 1000);
	keyboard.clearStuff();
}

init();
